/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If you would like to propose
 * a change to this component, please reach out to a
 * frontend engineer.
 *
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';
import Button, { ButtonType, ButtonProps, ButtonLinkProps } from 'hellospa/foundation/control/button';
import { ArrowPosition, ArrowDirection } from './types';
import ArrowIcon from './arrow-icon';
import styles from './arrow-button.scss';

export { ArrowPosition };
export { ArrowDirection };

type Props = (ButtonLinkProps | ButtonProps) & {
  position?: ArrowPosition,
  direction?: ArrowDirection,
  animated?: boolean,
};

function ArrowButton({
  position = ArrowPosition.Right,
  direction = ArrowDirection.Right,
  animated = true,
  children,
  ...props
}: Props, ref: React.Ref<any>) {
  const arrow = React.useMemo(() => {
    return (
      <span className={styles.buttonLinkArrow}>
        <ArrowIcon direction={direction} />
      </span>
    );
  }, [direction]);

  return (
    <Button
      ref={ref}
      kind={ButtonType.Link}
      className={classnames(styles.buttonLink, {
        [styles.withMotion]: animated,

        [styles.posLeft]: position === ArrowPosition.Left,
        [styles.posRight]: position === ArrowPosition.Right,
        [styles.dirUp]: direction === ArrowDirection.Up,
        [styles.dirDown]: direction === ArrowDirection.Down,
        [styles.dirLeft]: direction === ArrowDirection.Left,
        [styles.dirRight]: direction === ArrowDirection.Right,
      })}
      {...props}
    >
      {position === ArrowPosition.Left && arrow}
      {children}
      {position === ArrowPosition.Right && arrow}
    </Button>
  );
}

export default React.forwardRef(ArrowButton);
